/* eslint-disable react/jsx-props-no-spreading */
import { ThemeIcon, ThemeIconProps, useMantineTheme } from '@mantine/core';
import { FC, ReactNode } from 'react';

interface Props extends ThemeIconProps {
  children: ReactNode;
}

const BookitupThemeIcon: FC<Props> = ({ children, ...rest }) => {
  const { colorScheme, colors } = useMantineTheme();
  const darkMode = colorScheme === 'dark';

  return (
    <ThemeIcon
      size={20}
      variant="gradient"
      gradient={
        darkMode
          ? { from: colors.blue[1], to: colors.blue[4], deg: 135 }
          : { from: colors.blue[4], to: colors.blue[0], deg: 135 }
      }
      sx={{ cursor: 'pointer' }}
      {...rest}
    >
      {children}
    </ThemeIcon>
  );
};

export default BookitupThemeIcon;
